import { render, staticRenderFns } from "./BestAthletesEventList.vue?vue&type=template&id=2c628e16&"
import script from "./BestAthletesEventList.vue?vue&type=script&lang=ts&"
export * from "./BestAthletesEventList.vue?vue&type=script&lang=ts&"
import style0 from "./BestAthletesEventList.vue?vue&type=style&index=0&id=2c628e16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports